// Componente Polizas.vue
<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="6">
              <b-button size="sm" variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i>Exportar</b-button>
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTableData"
                  :data="datapoliza"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >
                  </el-table-column>

                  <el-table-column  label="" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <b-button size="sm" variant="primary" @click="recuperar_detpoliza(scope.row.poliza, 1, scope.row.endoso)" >Detalle</b-button>
                    </template>
                  </el-table-column>
                  
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      title="Detalle Póliza"
      cancel-title="Cancelar"
      v-model="modaldetpoliza"
      @cancel="modaldetpoliza = false"
    >
        <center><h5>COPIA NO VALIDA</h5></center>
        <p><b>Riesgo: </b> {{ this.datosFormulario.producto }} </p>
        <p><b>Póliza: </b> {{ this.datosFormulario.poliza }} <b>Propuesta:</b> {{ this.datosFormulario.propuesta }} <b>Sucursal:</b> {{ this.datosFormulario.sucursal }} </p>
        <p><b>Moneda: </b> {{ this.datosFormulario.moneda }} </p>
        <p><b>Corredor: </b> {{ this.datosFormulario.corredor }} <b>Rut: </b> {{ this.datosFormulario.rutnumcorred }}-{{ this.datosFormulario.rutdvcorred}} <b>Código: </b> {{ this.datosFormulario.codigocorred}}</p>
        <p><b>Contratante: </b> {{ this.datosFormulario.contratante }} <b>Rut: </b> {{ this.datosFormulario.rutnumcon }}-{{ this.datosFormulario.rutdvcon}}</p>
        <p><b>Dirección: </b> {{ this.datosFormulario.direccon }} </p>
        <p><b>Item: </b> {{ this.datosFormulario.item }} <b>Endoso: </b> {{ this.datosFormulario.endoso }}</p>
        <p><b>Asegurado: </b> {{ this.datosFormulario.asegurado }} <b>Rut: </b>{{ this.datosFormulario.rutnumaseg}}-{{ this.datosFormulario.rutdvaseg}}</p>
        <p><b>Dirección: </b> {{ this.datosFormulario.direcaseg }} </p>
        <p><b>Vig. Desde: </b> {{ this.datosFormulario.vigdesde }} <b>Vig. Hasta: </b> {{ this.datosFormulario.vighasta }}</p>
        <p><b>Acción: </b> {{ this.datosFormulario.accion }} </p>
        <br>
        <table class="table">
          <tr>
          <td align ="center"><b>Monto asegurado</b></td>		<td align ="center"><b>Prima neta</b></td>	<td align ="center"><b>IVA</b></td>
          </tr>
          <tr>
          <td align ="center">{{this.datosFormulario.montoaseg}}</td>		<td align ="center">{{this.datosFormulario.primaneta}}</td>	<td align ="center">{{this.datosFormulario.iva}}</td>
          </tr>
        </table>
        <br>
        <center><p><b>Detalle de Materia Asegurada</b></p></center>
        <p>{{this.datosFormulario.materia}}</p>
        <br>
        <p><b>Póliza</b> {{ this.datosFormulario.poliza }} <b>Endoso</b> {{ this.datosFormulario.endoso }} <b>Item</b> {{ this.datosFormulario.item }}  </p>
        <p><b>Firma Autorizada</b> </p>
        <br>
        <!-- <center><p><b>Observaciones</b></p></center>
        {{this.datosFormulario.observaciones}} -->

      
      <b-row>
    
      </b-row>
    </b-modal>

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  name: "Polizas",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    // title: { type: String },
    cod_asegurado: Number,
    participacion: Number,
    fedesde: Datepicker,
    fehasta: Datepicker
    // timeOnSite: { type: Number, required: true }
  },

  data: function() {
    return {
      datapoliza:[],
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      modaldetpoliza: false,
      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },

      nombreexcel: "Pólizas",

      datosFormulario: {
        producto: "",
        poliza: "",
        endoso: "",
        item: "",
        propuesta: "",
        accion: "",
        moneda: "",
        vigdesde: "",
        vighasta: "",
        montoaseg: "",
        primaneta: "",
        iva: "",
        materia: "",
        sucursal: "",
        corredor: "",
        rutnumcorred: "",
        rutdvcorred: "",
        codigocorred: "",
        asegurado: "",
        direcaseg: "",
        ciudadaseg: "",
        rutnumaseg: "",
        rutdvaseg: "",
        contratante: "",
        rutnumcon: "",
        rutdvcon: "",
        direccon: "",
        ciudadcon: "",
        observaciones: "",
      },
      
      titles: [
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "endoso",
          label: "Endoso",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "emision",
          label: "Fecha Emisión",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "accion",
          label: "Acción",
          align: "center",
          minwidth:'70'
        },      
        {
          prop: "vigdesde",
          label: "Vigencia Desde",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "vighasta",
          label: "Vigencia Hasta",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "mtoaseg",
          label: "Monto Asegurado",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "prima",
          label: "Prima",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "costo",
          label: "Costo",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "corredor",
          label: "Corredor",
          align: "center",
          minwidth:'100'
        }
        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

    }
  },
  methods: {

        formatter(row, column) {
          if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
        },

        recuperar_poliza() {
            this.$Progress.start(); 
           
            return apiConsultaCliente
              .recuperar_poliza(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.cod_asegurado,
                this.participacion,
                this.fedesde, 
                this.fehasta

              )  
              .then(response => {
                
                response.data = this.keysMinuscula(response.data);
                this.datapoliza = response.data.res;
                

                this.$Progress.finish();
              })
              .catch(error => {
                this.mensaje= "Error";
                this.variant="warning";
                this.showAlert = true;
                this.$Progress.finish();
              });
        },

        recuperar_detpoliza(p_poliza, p_item, p_endoso) {
          console.log(p_poliza, p_endoso);
            this.$Progress.start(); 
           
            return apiConsultaCliente
              .recuperar_detpoliza(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                p_poliza,
                p_item,
                p_endoso
              )  
              .then(response => {
                this.modaldetpoliza = true;
                
                response.data = this.keysMinuscula(response.data);
                var datadetpoliza = response.data.res;
                console.log(datadetpoliza);
                for (var i = 0; i < datadetpoliza.length; i++) {

                  this.datosFormulario.producto = datadetpoliza[i]["producto"];
                  this.datosFormulario.poliza = datadetpoliza[i]["poliza"];
                  this.datosFormulario.endoso = datadetpoliza[i]["endoso"];
                  this.datosFormulario.item = datadetpoliza[i]["item"];
                  this.datosFormulario.propuesta = datadetpoliza[i]["propuesta"];
                  this.datosFormulario.accion = datadetpoliza[i]["accion"];
                  this.datosFormulario.moneda = datadetpoliza[i]["moneda"];
                  this.datosFormulario.vigdesde = datadetpoliza[i]["vigdesde"];
                  this.datosFormulario.vighasta = datadetpoliza[i]["vighasta"];
                  this.datosFormulario.montoaseg = datadetpoliza[i]["montoaseg"];
                  this.datosFormulario.primaneta = datadetpoliza[i]["primaneta"];
                  this.datosFormulario.iva = datadetpoliza[i]["iva"];
                  this.datosFormulario.materia = datadetpoliza[i]["materia"];
                  this.datosFormulario.sucursal = datadetpoliza[i]["sucursal"];
                  this.datosFormulario.corredor = datadetpoliza[i]["corredor"];
                  this.datosFormulario.rutnumcorred = datadetpoliza[i]["rutnumcorred"];
                  this.datosFormulario.rutdvcorred = datadetpoliza[i]["rutdvcorred"];
                  this.datosFormulario.codigocorred = datadetpoliza[i]["codigocorred"];
                  this.datosFormulario.asegurado = datadetpoliza[i]["asegurado"];
                  this.datosFormulario.direcaseg = datadetpoliza[i]["direcaseg"];
                  this.datosFormulario.ciudadaseg = datadetpoliza[i]["ciudadaseg"];
                  this.datosFormulario.rutnumaseg = datadetpoliza[i]["rutnumaseg"];
                  this.datosFormulario.rutdvaseg = datadetpoliza[i]["rutdvaseg"];
                  this.datosFormulario.contratante = datadetpoliza[i]["contratante"];
                  this.datosFormulario.rutnumcon = datadetpoliza[i]["rutnumcon"];
                  this.datosFormulario.rutdvcon = datadetpoliza[i]["rutdvcon"];
                  this.datosFormulario.direccon = datadetpoliza[i]["direccon"];
                  this.datosFormulario.ciudadcon = datadetpoliza[i]["ciudadcon"];
                  this.datosFormulario.observaciones = datadetpoliza[i]["observacion"];

                }
                
                this.$Progress.finish();
              })
              .catch(error => {
                this.mensaje= "Error";
                this.variant="warning";
                this.showAlert = true;
                this.$Progress.finish();
              });
        },

        descargarExcel: function () {
        var cuerpo = "";
        var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
        var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
        var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

        cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=80 style='width:60pt'>";
        cuerpo += "\n";

        
        ///COLUMNAS ESCRIBIR
        cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Producto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Póliza" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Endoso" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Fecha Emisión" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Vigencia Desde" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Vigencia Hasta" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Moneda" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Monto Asegurado" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Prima" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Costo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Corredor" + "</td>\n";
        cuerpo += "</tr>\n";
        
        //Data bloque 1
        
        for (var key in this.datapoliza) {
          if(this.datapoliza[key]["producto"] === undefined){ 
            this.datapoliza[key]["producto"] = "";
          }
          if(this.datapoliza[key]["poliza"] === undefined){ 
            this.datapoliza[key]["poliza"] = "";
          }
          
          if(this.datapoliza[key]["endoso"] == undefined){ 
            this.datapoliza[key]["endoso"] = "";
          }
          if(this.datapoliza[key]["emision"] == undefined){ 
            this.datapoliza[key]["emision"] = "";
          }
          if(this.datapoliza[key]["vigdesde"] == undefined){ 
            this.datapoliza[key]["vigdesde"] = "";
          }
          if(this.datapoliza[key]["vighasta"] == undefined){ 
            this.datapoliza[key]["vighasta"] = "";
          }
          if(this.datapoliza[key]["moneda"] == undefined){ 
            this.datapoliza[key]["moneda"] = "";
          }
          if(this.datapoliza[key]["mtoaseg"] == undefined){ 
            this.datapoliza[key]["mtoaseg"] = "";
          }
          if(this.datapoliza[key]["prima"] == undefined){ 
            this.datapoliza[key]["prima"] = "";
          }
          if(this.datapoliza[key]["costo"] == undefined){ 
            this.datapoliza[key]["costo"] = "";
          }
          if(this.datapoliza[key]["corredor"] == undefined){ 
            this.datapoliza[key]["corredor"] = "";
          }
          

          cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datapoliza[key]["producto"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datapoliza[key]["poliza"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datapoliza[key]["endoso"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.datapoliza[key]["emision"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.datapoliza[key]["vigdesde"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.datapoliza[key]["vighasta"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datapoliza[key]["moneda"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datapoliza[key]["mtoaseg"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datapoliza[key]["prima"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datapoliza[key]["costo"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datapoliza[key]["corredor"] + "</td>\n";
          cuerpo += "</tr>\n";
        }

        //Data bloque 1
        
        this.export(
          this.generaExcelV2(this.nombreexcel, cuerpo),
          this.nombreexcel
        );
      },

      export:async function(data, filename) {
        if(typeof this.beforeFinish === 'function')
          await this.beforeFinish();
        download(data, filename,  "application/vnd.ms-excel");
      },

       

        
  },
      
  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_poliza();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>